import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-sidebar-reports',
  templateUrl: './sidebar-reports.component.html',
  styleUrls: ['./sidebar-reports.component.sass']
})
export class SidebarReportsComponent implements OnInit {
  authenticated$: any;

  constructor(
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authenticated$ = this.authService.getAuthenticatedUser();
  }
}
